export const FAVICON_LOGO_PATH = '/favicon/logo.svg';
export const LANDING_URL = 'https://dev.fcb.tm/';
export const TERMS_URL =
  'https://dev.fcb.tm/assets/FCB_NA_LTD_Terms_of_Service.pdf';
export const PRIVACY_POLICY_URL =
  'https://dev.fcb.tm/assets/FCB_NA_LTD_Privacy_Policy.pdf';
